module.exports = "/images/london-1.jpg";